<template>
  <div id="resorts-view" v-if="resorts.length > 1">
    <div class="ria-main-container limiter pt-10 lg:pt-20">
      <h2 class="title invisible-default text-center font-light text-black">
        {{ $t("resorts.where") }}
      </h2>
      <h5 class="subtitle invisible-default text-center font-light text-grey-text">
        {{ $t("resorts.choose") }}
      </h5>
      <div class="grid-1-to-3 w-full max-w-full">
        <div class="relative" v-for="resort in resorts" :key="resort.id">
          <div @click="chooseResort(resort.id)" class="card-resort">
            <img v-if="resort.photo != ''" :src="resort.photo"
              v-bind:alt="resort.name"
              class="image-resort h-40 max-h-none"
              />
            <img v-else src="../assets/img/img-placeholder-horizontal.png"
            v-bind:alt="resort.name"
            class="image-resort h-40 max-h-none"
            />
            <div class="gradient-title rounded-img">
              <h3 class="image-title text-white">
                {{ resort.name }}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {keepScroll} from "../mixins";

export default {
  name: "Landing",
  metaInfo() {
      return { 
          title: `${this.$t('resorts.meta.title')} - ${this.environment_name}`,
          meta: [
              { name: 'description', content:  this.$t('resorts.meta.description')}, 
          ]
      }
  },
  mixins: [keepScroll],
  computed: {
    ...mapGetters("resort", ["resorts", "environment_name"])
  },
  methods: {
    ...mapActions("resort", ["loadResort", "loadResorts"]),
    chooseResort(resortId) {
      this.loadResort({ id: resortId }).then(() => {
        this.$router.push({ name: 'Catalog' })
      });
    }
  },
  mounted () {
    if (this.resorts.length == 1) {
      this.chooseResort(this.resorts[0].id)
    }
  }
};
</script>

<style scoped>
.gradient-title {
  background-image: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.7));
  @apply absolute bottom-0 min-w-full min-h-1/2;
}
.ria-main-container {
  @apply bg-grey-bg;
}
#resorts-view {
  @apply bg-white;
}
.grid-1-to-3 {
  @apply mx-auto max-w-xs grid grid-cols-1 gap-2 pt-4 px-2;
}

.card-resort {
  @apply cursor-pointer;
}

.card-resort img {
  @apply rounded-img max-h-150 min-w-full;
}
.image-resort {
  object-fit: cover;
  object-position: 50% 50%;
}
@screen lg {
  #resorts-view {
    @apply w-screen;
  }
  .ria-main-container{
    @apply bg-white !important;
  }
  .card-resort img {
    @apply max-h-none;
    max-height: 250px;
  }
  .grid-1-to-3 {
    @apply max-w-none grid-cols-3 gap-10;
  }
}
</style>
